import EzrAudio from "./EzrAudio";

export default EzrAudio;
